export class MetaInfo {
  title: string;
  metaTags: { key: string; value: string }[];
  canonical: string;
  schemaGraph: object;

  constructor(
    title: string,
    metaTags: { key: string; value: string }[],
    canonical: string,
    schemaGraph: object
  ) {
    this.title = title;
    this.metaTags = metaTags;
    this.canonical = canonical;
    this.schemaGraph = schemaGraph;
  }
}
